export default __webpack_public_path__ + "static/media/BNBx.4b3cba3c.png";